import { render, staticRenderFns } from "./AccountNewPharmacy.vue?vue&type=template&id=14247c8b&"
import script from "./AccountNewPharmacy.vue?vue&type=script&lang=js&"
export * from "./AccountNewPharmacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports